import { axiosClient } from './axiosClient';
import type { ApiResponse } from '../types/api.types';
import type {
  EmailLog,
  NotificationFilter,
  NotificationItem,
  NotificationPreference,
  NotificationPreferenceUpdate,
  SystemAlertPayload,
  SystemAlertResult,
} from '../types/notification.types';

const buildParams = (filter: NotificationFilter) => {
  const out: Record<string, string | number | boolean> = {};
  if (filter.type) out.type = filter.type;
  if (filter.is_read !== undefined) out.is_read = filter.is_read;
  if (filter.date_from) out.date_from = filter.date_from;
  if (filter.date_to) out.date_to = filter.date_to;
  if (filter.limit !== undefined) out.limit = filter.limit;
  if (filter.offset !== undefined) out.offset = filter.offset;
  return out;
};

export const notificationApi = {
  getNotifications: async (filter: NotificationFilter = {}) => {
    const response = await axiosClient.get<ApiResponse<NotificationItem[]>>('/notifications', { params: buildParams(filter) });
    return response.data;
  },
  getUnreadCount: async () => {
    const response = await axiosClient.get<ApiResponse<{ count: number }>>('/notifications/unread-count');
    return response.data;
  },
  markRead: async (notificationId: string) => {
    const response = await axiosClient.post<ApiResponse<NotificationItem>>(`/notifications/${notificationId}/read`);
    return response.data;
  },
  markAllRead: async () => {
    const response = await axiosClient.post<ApiResponse<{ marked_read: number }>>('/notifications/read-all');
    return response.data;
  },
  getPreferences: async () => {
    const response = await axiosClient.get<ApiResponse<NotificationPreference>>('/notifications/preferences');
    return response.data;
  },
  updatePreferences: async (payload: NotificationPreferenceUpdate) => {
    const response = await axiosClient.put<ApiResponse<NotificationPreference>>('/notifications/preferences', payload);
    return response.data;
  },
};

export const adminNotificationApi = {
  getEmailLogs: async (limit = 200) => {
    const response = await axiosClient.get<ApiResponse<EmailLog[]>>('/admin/notifications/email-logs', { params: { limit } });
    return response.data;
  },
  sendSystemAlert: async (payload: SystemAlertPayload) => {
    const response = await axiosClient.post<ApiResponse<SystemAlertResult>>('/admin/notifications/send-system-alert', payload);
    return response.data;
  },
};
